(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__msSwipe) return;
    window.__msSwipe = true;
    var slidesOf = function (sc) {
      return Array.prototype.filter.call(sc.children, function (el) { return el.tagName === 'SLIDESHOW-SLIDE' && !el.hidden; });
    };
    var hydrate = function (g) {
      if (!g || g.__msHyd) return;
      g.__msHyd = 1;
      var w = Math.ceil(g.clientWidth || 200) + 'px';
      g.querySelectorAll('img[data-ms-src]').forEach(function (im) {
        im.sizes = w;
        if (im.dataset.msSrcset) im.srcset = im.dataset.msSrcset;
        im.src = im.dataset.msSrc;
        im.removeAttribute('data-ms-src'); im.removeAttribute('data-ms-srcset');
      });
    };
    var wake = function (e) {
      var c = e.target instanceof Element && e.target.closest('product-card, .card-gallery.ms-swipe');
      var g = c && (c.matches('.card-gallery') ? c : c.querySelector('.card-gallery.ms-swipe'));
      if (g) hydrate(g);
    };
    ['touchstart', 'pointerenter', 'pointerdown', 'focusin'].forEach(function (t) { document.addEventListener(t, wake, { capture: true, passive: true }); });
    // MS (Oct 27): desktop hover peek at the 2nd image (fine pointers only)
    var mqPeek = window.matchMedia('(hover: hover) and (pointer: fine)');
    var peekImg = function (g) {
      var im = g.querySelector('.ms-peek-img');
      if (im || g.__msNoPeek) return im;
      var sc = g.querySelector('slideshow-slides'), s = sc && slidesOf(sc);
      var box = s && s.length > 1 && s[0].querySelector('.product-media');
      var a = box && box.querySelector('img'), b = s && s.length > 1 && s[1].querySelector('img');
      if (!a || !b) { g.__msNoPeek = 1; return null; }
      im = document.createElement('img');
      im.className = a.className + ' ms-peek-img';
      im.alt = ''; im.setAttribute('aria-hidden', 'true');
      im.loading = 'lazy'; im.decoding = 'async';
      if (b.getAttribute('style')) im.setAttribute('style', b.getAttribute('style'));
      im.sizes = Math.ceil(g.clientWidth || 200) + 'px';
      var ss = b.dataset.msSrcset || b.getAttribute('srcset');
      if (ss) im.srcset = ss;
      im.src = b.dataset.msSrc || b.getAttribute('src');
      box.appendChild(im);
      return im;
    };
    var atStart = function (g) { var sc = g.querySelector('slideshow-slides'); return !sc || sc.scrollLeft < 2; };
    var prep = function () {
      if (!mqPeek.matches) return;
      document.querySelectorAll('.card-gallery.ms-swipe:not([data-ms-peek])').forEach(function (g) {
        if (!g.clientWidth) return;
        g.setAttribute('data-ms-peek', '');
        peekImg(g);
      });
    };
    document.addEventListener('pointerenter', function (e) {
      var g = e.target;
      if (!mqPeek.matches || e.pointerType !== 'mouse' || !(g instanceof Element) || !g.matches('.card-gallery.ms-swipe')) return;
      var im = peekImg(g);
      if (!im || !atStart(g)) return;
      var on = function () { if (g.matches(':hover') && atStart(g)) g.classList.add('ms-peek-on'); };
      if (im.complete && im.naturalWidth) on();
      else { im.loading = 'eager'; im.addEventListener('load', on, { once: true }); }
    }, { capture: true, passive: true });
    document.addEventListener('pointerleave', function (e) {
      var g = e.target;
      if (g instanceof Element && g.matches('.card-gallery.ms-swipe')) g.classList.remove('ms-peek-on');
    }, { capture: true, passive: true });
    var snapOff = function (g) {
      g.classList.add('ms-peek-snap'); g.classList.remove('ms-peek-on');
      requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.remove('ms-peek-snap'); }); });
    };
    var update = function (g) {
      var sc = g.querySelector('slideshow-slides');
      if (!sc) return;
      var w = sc.clientWidth || 1, i = Math.round(sc.scrollLeft / w), n = slidesOf(sc).length;
      if (i > n - 1) i = n - 1;
      var d = g.querySelectorAll('.ms-swipe__dashes span');
      for (var k = 0; k < d.length; k++) d[k].classList.toggle('is-active', k === i);
      var p = g.querySelector('[data-ms-swipe="-1"]'), nx = g.querySelector('[data-ms-swipe="1"]');
      if (p) p.disabled = i <= 0;
      if (nx) nx.disabled = i >= n - 1;
    };
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!(t instanceof Element) || t.tagName !== 'SLIDESHOW-SLIDES') return;
      var g = t.closest('.card-gallery.ms-swipe');
      if (g) { hydrate(g); update(g); if (t.scrollLeft >= 2 && g.classList.contains('ms-peek-on')) g.classList.remove('ms-peek-on'); }
    }, { capture: true, passive: true });
    document.addEventListener('click', function (e) {
      var b = e.target instanceof Element && e.target.closest('[data-ms-swipe]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var g = b.closest('.card-gallery.ms-swipe'), sc = g && g.querySelector('slideshow-slides');
      if (!sc) return;
      hydrate(g);
      if (g.classList.contains('ms-peek-on') && Number(b.dataset.msSwipe) > 0 && atStart(g)) {
        // already showing image 2 via the hover peek: jump straight to slide 2 so the next click shows image 3
        sc.scrollTo({ left: sc.clientWidth, behavior: 'instant' });
        snapOff(g);
        return;
      }
      sc.scrollTo({ left: sc.scrollLeft + Number(b.dataset.msSwipe) * sc.clientWidth, behavior: 'smooth' });
    }, true);
    var init = function () { document.querySelectorAll('.card-gallery.ms-swipe').forEach(update); prep(); };
    // infinite scroll / section re-renders append new cards: prepare their hover image (lazy, so only near-viewport cards load)
    var prepQ = 0;
    new MutationObserver(function () {
      if (prepQ || !mqPeek.matches) return;
      prepQ = requestAnimationFrame(function () { prepQ = 0; prep(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
